export default "__VITE_ASSET__Fm2eJ5LO__"